import YieldIcon from './component.jsx'
export default YieldIcon
